import React from 'react';

const MUSEUM_EXHIBIT_POSITIONS = [
  { x: '18%', height: '2.55rem' },
  { x: '35%', height: '3.18rem' },
  { x: '52%', height: '2.72rem' },
  { x: '68%', height: '3rem' },
  { x: '82%', height: '2.46rem' },
];

const MuseumVisual = ({ revealMeta = {} }) => {
  const museumState = revealMeta.museumState || {};
  const exhibits = museumState.exhibits?.length ? museumState.exhibits.slice(0, 5) : [
    { label: 'Photo', type: 'photo' },
    { label: 'Note', type: 'note' },
    { label: 'Date', type: 'date' },
  ];

  return (
    <span
      className={`lumirae-layer-visual lumirae-layer-visual-museum is-${museumState.style || 'gallery-case'}${museumState.hasExhibits ? ' has-exhibits' : ' is-empty'}`}
      data-exhibit-count={museumState.count || exhibits.length}
      aria-hidden="true"
    >
      <span className="case">
        {exhibits.map((exhibit, index) => {
          const position = MUSEUM_EXHIBIT_POSITIONS[index] || MUSEUM_EXHIBIT_POSITIONS[MUSEUM_EXHIBIT_POSITIONS.length - 1];
          return (
            <span
              key={`${exhibit.label}_${index}`}
              className={`exhibit exhibit-${index} is-${exhibit.type || 'ticket'}`}
              style={{
                '--exhibit-x': position.x,
                '--exhibit-height': position.height,
                '--exhibit-delay': `${420 + index * 90}ms`,
              }}
            >
              <b />
              <small>{exhibit.dateLabel || exhibit.label}</small>
            </span>
          );
        })}
      </span>
      <span className="lights">
        <b />
        <b />
        <b />
      </span>
      <span className="shelf" />
    </span>
  );
};

export default MuseumVisual;
